//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'RoutePriceTable',
  props: {
    tickets: {
      type: Array,
      required: true,
    },
  },
}



// WEBPACK FOOTER //
// ./client/components/Common/RoutePriceTable.vue